module.exports = __webpack_public_path__ + "img/gear.fc9524ec.svg";